import {useEffect, useState} from 'react';
import {fetchPatientDetailsUuid, postPatientBill} from '../Redux/Thunk/Actions';
import '../styles/PatientReportFileTemplateCreate.scss';

import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {SelectPicker} from 'rsuite';
import Swal from 'sweetalert2';
import {Consultation, injections, price, procedures, scan} from '../Context/GlobalData';
import FigmaHeader from './FigmaHeader/FigmaHeader';
import NumbersToWords from './Global_Components/Converters/NumberToWord';

function BillGenerateTemplate(props) {
  const [dropSelectionData, setDropSelectionData] = useState({});
  // console.log(dropSelectionData, "lllllll");
  const [rowValueUpdate, setRowValueUpate] = useState(1);
  const [customInputStatus, setCustomInputStatus] = useState({});
  const [updatesno, setUpdatesno] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState({});
  const [show, setShow] = useState(false);
  const [customTagPrice, setCustomTagPrice] = useState(price);
  const [modeOfPmt, setModeOfPmt] = useState({mode_one: 'Cash', mode_two: 'Card', mode_three: 'UPI', mode_four: 'NEFT'});
  const [amountInPmt, setAmountInPmt] = useState({amount_one: '', amount_two: '', amount_three: '', amount_four: ''});
  const [cashTru, setCashTru] = useState(true);
  const [cardTru, setCardTru] = useState(true);
  const [upiTru, setUpiTru] = useState(true);
  const [neftTru, setNeftTru] = useState(true);
  const [error, setError] = useState('');

  const [valueChange, setValueChange] = useState({
    gender1: 'Male',
    gender2: 'Male',
    bloodGroup1: 'A+',
    bloodGroup2: 'A+',
    age: '',
    gender1: '',
    docRef: '',
    name: '',
    dateTime: '',
    cash: '',
    name: '',
    uhid: '',
    returnedBalance: ''
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const initialRow = {
    sno: 1,
    title: 'Doctor Consultation fees',
    remark: '',
    amount: ''
  };
  const [rows, setRows] = useState([initialRow]);
  const [arrayForTotal, setArrayForTotal] = useState({});
  const [patientid, setpatientid] = useState('');

  //
  const [ScanData, setScanData] = useState([
    {
      scan: '',
      remarks: '',
      price: '',
      concession: ''
    }
  ]);
  const [ProcedureData, setProcedureData] = useState([
    {
      procedure: '',
      remarks: '',
      price: '',
      concession: ''
    }
  ]);
  const [ConsultationData, setConsultationData] = useState([
    {
      consultation: '',
      remarks: '',
      price: '',
      concession: ''
    }
  ]);
  const [PharmacyData, setPharmacyData] = useState({
    Pharmacy: '',
    Refer_Prescription: '',
    price: ''
  });
  // console.log(PharmacyData, "PharmacyData")
  const [InjectionData, setInjuctionData] = useState([{Injection: '', Items: '', price: '', concession: ''}]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setTotal(500);
  }, []);

  // console.log(ScanData, ProcedureData, ConsultationData);
  useEffect(() => {
    // console.log(
    //   InjectionData[0].Injection.length,
    //   "InjectionDataInjectionData"
    // );
  }, [InjectionData]);
  const add = name => {
    if (name == 'scan') {
      const newData = {
        [`scan`]: '',
        [`remarks`]: '',
        [`price`]: '',
        [`concession`]: ''
      };
      // console.log(newData);
      setScanData(prev => [...prev, newData]);
    } else if (name == 'procedure') {
      const newData = {
        [`procedure`]: '',
        [`remarks`]: '',
        [`price`]: '',
        [`concession`]: ''
      };
      // console.log(newData);
      setProcedureData(prev => [...prev, newData]);
    } else if (name == 'injection') {
      const newData = {
        [`Injection`]: '',
        [`Items`]: '',
        [`price`]: '',
        [`concession`]: ''
      };
      // console.log(newData);
      setInjuctionData(prev => [...prev, newData]);
    } else {
      const newData = {
        [`consultation`]: '',
        [`remarks`]: '',
        [`price`]: '',
        [`concession`]: ''
      };
      // console.log(newData);
      setConsultationData(prev => [...prev, newData]);
    }
  };
  const sub = (name, indexToRemove) => {
    if (name == 'scan') {
      setScanData(prev => prev.filter((_, index) => index !== indexToRemove));
    } else if (name == 'procedure') {
      setProcedureData(prev => prev.filter((_, index) => index !== indexToRemove));
    } else if (name == 'injection') {
      setInjuctionData(prev => prev.filter((_, index) => index !== indexToRemove));
    } else {
      setConsultationData(prev => prev.filter((_, index) => index !== indexToRemove));
    }
  };
  // useEffect(() => {
  //   const allData = [...ScanData, ...ProcedureData, ...ConsultationData];
  //   const total = allData.reduce(
  //     (total, item) => total + parseFloat(item.price || 0),
  //     0
  //   );
  //   setTotal(total);
  // }, [ScanData, ProcedureData, ConsultationData]);

  const paymentType = e => {
    console.log(e.target.value);
    if (e.target.checked && e.target.value == 'cash') {
      setCashTru(false);
      setAmountInPmt({...amountInPmt, amount_one: ''});
    } else if (e.target.checked && e.target.value == 'card') {
      setCardTru(false);
      setAmountInPmt({...amountInPmt, amount_two: ''});
    } else if (e.target.checked && e.target.value == 'upi') {
      setUpiTru(false);
      setAmountInPmt({...amountInPmt, amount_three: ''});
    } else if (e.target.checked && e.target.value == 'neft') {
      setNeftTru(false);
      setAmountInPmt({...amountInPmt, amount_four: ''});
    }
    if (!e.target.checked && e.target.value == 'cash') {
      setCashTru(true);
      setAmountInPmt({...amountInPmt, amount_one: ''});
      console.log(e.target.value);
    } else if (!e.target.checked && e.target.value == 'card') {
      setCardTru(true);
      setAmountInPmt({...amountInPmt, amount_two: ''});
    } else if (!e.target.checked && e.target.value == 'upi') {
      setUpiTru(true);
      setAmountInPmt({...amountInPmt, amount_three: ''});
    } else if (!e.target.checked && e.target.value == 'neft') {
      setNeftTru(true);
      setAmountInPmt({...amountInPmt, amount_four: ''});
    }
  };

  const amountEnter = e => {
    console.log(amountInPmt);

    if (e.target.value == '' || e.target.value == ' ') {
      setAmountInPmt({...amountInPmt, [e.target.name]: ''});
    } else {
      const val = /^-?\d+(\.\d{1,2})?$/.test(e.target.value);
      // console.log(val);
      if (val) {
        setAmountInPmt({...amountInPmt, [e.target.name]: Number(e.target.value)});
      }
    }
  };

  useEffect(() => {
    const allData = [...ScanData, ...ProcedureData, ...ConsultationData, ...InjectionData, PharmacyData];
    const total = allData.reduce((total, item) => {
      const itemPrice = parseFloat(item.price || 0);
      const itemConcession = parseFloat(item.concession || 0);
      return total + itemPrice - itemConcession;
    }, 0);
    setTotal(total);
  }, [ScanData, ProcedureData, ConsultationData, PharmacyData, InjectionData]);

  const addRow = () => {
    const newRow = {
      ...initialRow,
      sno: rows.length + rowValueUpdate
    };
    setRows(prevRows => [...prevRows, newRow]);
  };

  const getFormattedDateTime = time => {
    console.log(`time -->`, time);

    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const getDateTimeForHidden = time => {
    console.log(`time -->`, time);
    if (!time) return;
    const timeValue = time.split('T')[0];
    const [year, month, day] = timeValue.split('-');
    const [hours, minutes] = time.split('T')[1].split(':');
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  useEffect(() => {
    const generateUniqueNumber = () => {
      const timestamp = new Date().getTime();
      const randomPart = Math.random().toString(36).substring(2, 8);
      const uniqueId = `${timestamp}${randomPart}`.substring(0, 12);
      return uniqueId;
    };

    const updateDateTime = () => {
      const formattedDateTime = getFormattedDateTime();
      const billUniqueId = generateUniqueNumber();
      setValueChange({
        ...valueChange,
        dateTime: formattedDateTime,
        billNo: billUniqueId
      });
    };

    updateDateTime();
  }, []);
  useEffect(() => {
    // console.log(valueChange, "hulahulahu");
  }, [valueChange]);

  const handleChange = e => {
    if (e.target.name === 'uhid') {
      // console.log("Going in1");
      const uhidValue = e.target.value?.trim();
      const isAscasFormat = /^(ASCAS|VDASCAS)\d+$/i.test(uhidValue);
      setValueChange({
        ...valueChange,
        uhid: e.target.value
      });
      if (isAscasFormat) {
        // console.log("Going inGoing inGoing inGoing inGoing in");

        const fetchData = async e => {
          const payload = {
            p_uhid: uhidValue,
            skipBranchFilter: true
          };
          props.loaderchange('true');

          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);

          if (response.payload?.status?.code === 200) {
            if (response.payload.data.data.length === 0) {
              setValueChange({
                ...valueChange,
                name: '',
                age: '',
                gender1: '',
                docRef: '',
                uhid: e.target.value

                // uhid: e.target.value,
              });
              props.popuptext('Patient uuid does not exist.');
              props.popupalert('true');
              props.loaderchange('false');
              setTimeout(() => {
                props.popupalert('false');
              }, 2000);
            } else {
              if (response.payload.data.data.length == 2) {
                var data = response.payload.data.data[0].p_uhid == e.target.value ? response.payload.data.data[0] : response.payload.data.data[1];
              } else {
                var data = response.payload.data.data[0];
              }

              // setFinalPatientsData(response.payload.data);
              const namePat = data.titles + ' ' + data.first_name + ' ' + data.last_name;
              // console.log(response.payload.data[0], "sending a response");
              setpatientid(data.id);
              setValueChange({
                ...valueChange,
                name: namePat,
                age: data.age,
                gender1: data.gender,
                docRef: data.doctor_name,
                uhid: e.target.value

                // uhid: e.target.value,
              });
              props.loaderchange('false');
            }
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
          return;
        };

        fetchData(e);
      } else {
        setValueChange({
          ...valueChange,
          uhid: e.target.value
        });
      }
    } else {
      // console.log("Going in");
      setValueChange({...valueChange, [e.target.name]: e.target.value});
    }
  };

  const handleBill = () => {
    if (valueChange?.name != '' && valueChange?.uhid != '' && (!cashTru || !cardTru || !upiTru || !neftTru)) {
      setShow(true);
      setTimeout(() => {
        console.log(amountInPmt);
        const CreateThunk = async () => {
          let htmlPayload;
          htmlPayload = document.getElementById('reportcreate').innerHTML;
          const payload = {
            report_template: htmlPayload,
            patient_id: patientid,
            pharmacy: PharmacyData.Pharmacy,
            pharmacy_prescription: PharmacyData.Refer_Prescription,
            pharmacy_price: PharmacyData.price,
            bill_price: discountCalculator(valueChange?.disc),
            ...amountInPmt,
            ...modeOfPmt,
            created_at: valueChange.dateTime
          };

          // Check if "OT charges" is selected in ProcedureData
          const otProcedure = ProcedureData.find(item => item.procedure === 'OT charges');

          if (otProcedure) {
            payload.ot_charges = otProcedure.procedure;
            payload.ot_remarks = otProcedure.remarks;
            payload.ot_price = otProcedure.price;
          }
          props.loaderchange(true);

          const patentReport = postPatientBill(payload);
          const response = await dispatch(patentReport);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/patient_billing');
            Swal.fire({
              title: 'Successful.',
              text: 'Report added successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        };
        CreateThunk();
      }, 2000);
    } else {
      props.popupalert('true');
      if (valueChange?.name == '' && valueChange?.uhid == '') {
        props.popuptext('Please Select Patient');
      } else {
        props.popuptext('Please Select Mode of Payment');
      }
      setTimeout(() => {
        props.popupalert('false');
      }, 2000);
    }
  };

  useEffect(() => {
    if (document?.getElementById(`value${updatesno}`)?.innerText != null) {
      const demo = document.getElementById(`value${updatesno}`).innerText;
      // console.log(demo, "uhdkh");
      setArrayForTotal(prevObject => ({
        ...prevObject,
        [`valueIn${updatesno}`]: demo
      }));
    }
  }, [dropSelectionData, customTagPrice]);

  useEffect(() => {
    // console.log(arrayForTotal, "9999");
    const sum = Object.values(arrayForTotal).reduce((acc, currentValue) => {
      return acc + parseInt(currentValue, 10);
    }, 0);

    setTotal(sum);
  }, [arrayForTotal]);

  /* const discountCalculator = discount => {
    if (discount > 0 && total > 0) {
      return total - (total * discount) / 100;
    } else {
      return total;
    }
  };*/

  const discountCalculator = discount => {
    if (discount > 0 && total > 0) {
      return total - discount;
    } else {
      return total;
    }
  };

  useEffect(() => {
    const netAmount = Math.round(discountCalculator(valueChange.disc));
    const totalPaid = Number(amountInPmt.amount_one || 0) + Number(amountInPmt.amount_two || 0) + Number(amountInPmt.amount_three || 0) + Number(amountInPmt.amount_four || 0);

    if (totalPaid > netAmount) {
      const returned = totalPaid - netAmount;
      setValueChange(prev => ({...prev, returnedBalance: returned.toFixed(2)}));
    } else {
      setValueChange(prev => ({...prev, returnedBalance: 0}));
    }
  }, [amountInPmt, valueChange.disc, total]);

  const convertToShortDate = dateTimeLocal => {
    const [date] = dateTimeLocal.split('T');
    const [year, month, day] = date.split('-');
    return `${parseInt(day)}-${parseInt(month)}-${year}`;
  };

  return (
    <>
      <div style={{backgroundColor: 'white'}} className='patientreport' id='reportcreate'>
        {/* Details-1 */}
        <div
          style={{
            maxWidth: '97%',
            margin: '0 auto',
            // border: "1px solid",
            // borderTop: "none",
            marginTop: '20px'
            // border: "1px solid",
          }}>
          {/* <FigmaHeader /> */}
          <FigmaHeader editedDate={convertToShortDate(valueChange?.dateTime)} />

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '2fr 1fr',
              alignItems: 'start',
              gap: '32px',
              overflowX: 'hidden',
              maxWidth: '100%',
              margin: '0 auto',
              borderBottom: '1px solid'
            }}
            className='report-template-wrap2'>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'center',
                gap: '10px',
                padding: '16px 8px 16px 8px'
              }}>
              {/* uhid */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center'
                }}>
                <span style={{fontWeight: 600}}>
                  UHID<span style={{color: 'red'}}>*</span>
                </span>
                <span style={{fontWeight: 600, paddingLeft: '102px'}}>:</span>
                <input
                  type='text'
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  maxLength={'20'}
                  value={valueChange.uhid}
                  onChange={e => handleChange(e)}
                  name='uhid'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px',
                    marginLeft: '10px'
                  }}
                />
                <span className={`input ${!show ? 'hide' : 'show'}`} style={{marginLeft: '15px'}}>
                  {valueChange.uhid}
                </span>
              </div>
              {/* Name*/}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '152px 16px 176px',
                  alignItems: 'center'
                }}>
                <span style={{fontWeight: 600}}>
                  Pat.Name<span style={{color: 'red'}}>*</span>
                </span>
                <span style={{fontWeight: 600}}>:</span>
                <input
                  type='text'
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  value={valueChange.name}
                  onChange={e => handleChange(e)}
                  name='name'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px'
                  }}
                />
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{valueChange.name}</span>
              </div>
              {/* Age/Sex */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '152px 16px 176px',
                  alignItems: 'center'
                }}>
                <span style={{fontWeight: 600}}>
                  Age/Sex<span style={{color: 'red'}}>*</span>
                </span>
                <span style={{fontWeight: 600}}>:</span>
                <div style={{display: 'flex'}}>
                  <div>
                    <input
                      type='text'
                      className={`createTime ${show ? 'hide' : 'show'}`}
                      onChange={e => handleChange(e)}
                      name='age'
                      value={valueChange.age}
                      style={{
                        border: '1px solid #ddd',
                        outline: 'none',
                        padding: '10px'
                      }}
                    />
                    <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{valueChange.age}</span>
                  </div>
                  <div>
                    <select
                      className={`createTime ${show ? 'hide' : 'show'}`}
                      onChange={e => handleChange(e)}
                      value={valueChange.gender1}
                      name='gender1'
                      style={{
                        border: '1px solid #ddd',
                        outline: 'none',
                        padding: '10px',
                        backgroundColor: 'white'
                      }}>
                      <option value='' disabled selected>
                        Select Gender
                      </option>
                      <option value='Male'>Male</option>
                      <option value='Female'>Female</option>
                      <option value='Others'>Others</option>
                      <option value='Decline to State'>Decline to State</option>
                    </select>
                    <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{valueChange.gender1}</span>
                  </div>
                </div>
              </div>
              {/* Ref Doc*/}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '152px 16px 176px',
                  alignItems: 'center'
                }}>
                <span style={{fontWeight: 600}}>Ref.Dr</span>
                <span style={{fontWeight: 600}}>:</span>
                <input
                  type='text'
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  value={valueChange.docRef}
                  onChange={e => handleChange(e)}
                  name='docRef'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px'
                  }}
                />
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{valueChange.docRef}</span>
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'center',
                gap: '10px',
                padding: '16px 8px 16px 8px'
              }}>
              {/* Bill no */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '152px 16px 176px',
                  alignItems: 'center'
                }}>
                <span style={{fontWeight: 600}}>Bill No</span>
                <span style={{fontWeight: 600}}>:</span>
                <p className={`createTime ${show ? 'hide' : 'show'}`} style={{margin: '0'}}>
                  {valueChange.billNo}
                </p>
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{valueChange.billNo}</span>
              </div>

              {/* Data/Time */}

              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '152px 16px 176px',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                <span style={{fontWeight: 600}}>Date/Time</span>
                <span style={{fontWeight: 600}}>:</span>
                <input
                  type='datetime-local'
                  style={{margin: 0, border: 'none'}}
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  name='dateTime'
                  value={valueChange.dateTime}
                  onChange={handleChange}
                />
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{getDateTimeForHidden(valueChange.dateTime)}</span>
              </div>

              {/* Terms */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '152px 16px 176px',
                  alignItems: 'center'
                }}>
                <span style={{fontWeight: 600}}>Terms</span>
                <span style={{fontWeight: 600}}>:</span>
                <input
                  type='text'
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  onChange={e => handleChange(e)}
                  name='terms'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px'
                  }}
                />
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{valueChange.terms}</span>
              </div>
              {/* Toke */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '152px 16px 176px',
                  alignItems: 'center'
                }}>
                <span style={{fontWeight: 600}}>Token</span>
                <span style={{fontWeight: 600}}>:</span>
                <input
                  type='text'
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  onChange={e => handleChange(e)}
                  name='token'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px'
                  }}
                />
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{valueChange.token}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            maxWidth: '97%',
            margin: '0 auto',
            // paddingTop: "10px",
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            overflowX: 'scroll',
            width: '100%',
            paddingTop: '30px',
            paddingBottom: '30px'
          }}>
          <table
            style={{
              borderSpacing: '0',
              width: '98%'
              // margin: "0 auto 30px auto",
            }}
            id='myTable'
            className='transition'>
            <thead style={{border: '1px solid', padding: '0px'}}>
              <tr
                style={{
                  border: '1px solid',
                  borderSpacing: '0px',
                  borderCollapse: 'collapse'
                }}>
                <th style={{padding: '10px'}}>Description</th>
                <th style={{border: '1px solid', padding: '10px'}}>Remarks</th>
                <th style={{border: '1px solid', padding: '10px'}}>Amount</th>
                <th style={{border: '1px solid', padding: '10px'}}>Concession</th>
              </tr>
            </thead>
            <tbody>
              <tr
                style={{
                  borderBottom: '1px solid',
                  borderSpacing: '0px',
                  borderCollapse: 'collapse',
                  height: '100%',
                  borderLeft: '1px solid'
                }}
                className='transition'>
                <td
                  style={{
                    padding: '10px',
                    position: 'relative',
                    display: 'block',
                    // outline: "1px solid",
                    height: '100%',
                    border: 'none'
                    // borderLeft: "1px solid",
                  }}>
                  <>
                    {Object.keys(ScanData).map((key, index) => {
                      return (
                        <div key={index}>
                          <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                            Select Scan
                          </p>
                          <div className={`createTime ${show ? 'hide' : 'show'}`}>
                            <SelectPicker
                              data={scan}
                              style={{width: 300}}
                              searchable
                              placeholder='Select Group'
                              value={ScanData[key][`scan`]}
                              onChange={e => {
                                setScanData(prevData => {
                                  const newData = [...prevData];
                                  newData[index] = {
                                    ...newData[index],
                                    scan: e || '',
                                    price: e ? price[e] : ''
                                  };

                                  return newData;
                                });
                              }}
                            />
                            {index == 0 ? (
                              <button
                                className={`Plus ${show ? 'hide' : 'show'}`}
                                onClick={e => {
                                  add('scan');
                                }}>
                                +
                              </button>
                            ) : (
                              <button
                                className={`minus ${show ? 'hide' : 'show'}`}
                                onClick={e => {
                                  sub('scan', index);
                                }}>
                                -
                              </button>
                            )}
                          </div>
                          <p className={`createTime ${!show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                            {ScanData[key][`scan`]}
                          </p>
                        </div>
                      );
                    })}
                    {Object.keys(ProcedureData).map((key, index) => {
                      return (
                        <div>
                          <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                            Select procedure
                          </p>
                          <div className={`createTime ${show ? 'hide' : 'show'}`}>
                            <SelectPicker
                              data={selectedGroup ? procedures : []}
                              style={{width: 300}}
                              searchable
                              placeholder='Select Sub-topic'
                              value={ProcedureData[key][`procedure`]}
                              onChange={e => {
                                setProcedureData(prevData => {
                                  const newData = [...prevData];
                                  newData[index] = {
                                    ...newData[index],
                                    procedure: e || '',
                                    price: e ? price[e] : ''
                                  };

                                  return newData;
                                });
                                // setProcedureData((prevData) => {
                                //   const newData = [...prevData];
                                //   newData[index] = {
                                //     ...newData[index],
                                //     procedure: e,
                                //     price: price[e],
                                //   };
                                //   return newData;
                                // });
                              }}
                            />
                            {index == 0 ? (
                              <button
                                className={`Plus ${show ? 'hide' : 'show'}`}
                                onClick={e => {
                                  add('procedure');
                                }}>
                                +
                              </button>
                            ) : (
                              <button
                                className={`minus ${show ? 'hide' : 'show'}`}
                                onClick={e => {
                                  sub('procedure', index);
                                }}>
                                -
                              </button>
                            )}
                          </div>
                          <p className={`createTime ${!show ? 'hide' : 'show'}`}>{ProcedureData[key][`procedure`]}</p>
                        </div>
                      );
                    })}
                    {/* SMH */}
                    {Object.keys(ConsultationData).map((key, index) => {
                      return (
                        <div>
                          <p
                            className={`createTime ${show ? 'hide' : 'show'}`}
                            style={{
                              display: 'block',
                              width: '100%',
                              padding: '5px 0 0 0px'
                            }}>
                            Consultation
                          </p>
                          <div className={`createTime ${show ? 'hide' : 'show'}`}>
                            <SelectPicker
                              data={Consultation}
                              style={{width: 300}}
                              searchable
                              placeholder='Select Consultation'
                              value={ConsultationData[key][`consultation`]}
                              onChange={e => {
                                setConsultationData(prevData => {
                                  const newData = [...prevData];
                                  newData[index] = {
                                    ...newData[index],
                                    consultation: e,
                                    price: price[e]
                                  };
                                  return newData;
                                });
                              }}
                            />
                          </div>

                          <p className={`createTime ${!show ? 'hide' : 'show'}`}>{ConsultationData[key][`consultation`]}</p>
                        </div>
                      );
                    })}
                  </>
                </td>
                <td style={{border: '1px solid', padding: '10px'}}>
                  {Object.keys(ScanData).map((key, index) => {
                    return (
                      <div key={index}>
                        <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          Scan Remarks
                        </p>
                        <input
                          className={`createTime ${show ? 'hide' : 'show'}`}
                          value={ScanData[key][`remarks`]}
                          style={{
                            padding: '5px',
                            outline: 'none',
                            border: '0px'
                          }}
                          onChange={e => {
                            setScanData(prevData => {
                              const newData = [...prevData];
                              newData[index] = {
                                ...newData[index],
                                remarks: e.target.value
                              };
                              return newData;
                            });
                          }}
                        />
                        <p className={`createTime ${!show ? 'hide' : 'show'}`}>{ScanData[key][`remarks`]}</p>
                      </div>
                    );
                  })}
                  {Object.keys(ProcedureData).map((key, index) => {
                    return (
                      <div key={index}>
                        <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          Procedure Remarks
                        </p>
                        <input
                          className={`createTime ${show ? 'hide' : 'show'}`}
                          value={ProcedureData[key][`remarks`]}
                          style={{
                            padding: '5px',
                            outline: 'none',
                            border: '0px'
                          }}
                          onChange={e => {
                            setProcedureData(prevData => {
                              const newData = [...prevData];
                              newData[index] = {
                                ...newData[index],
                                remarks: e.target.value
                              };
                              return newData;
                            });
                          }}
                        />
                        <p className={`createTime ${!show ? 'hide' : 'show'}`}>{ProcedureData[key][`remarks`]}</p>
                      </div>
                    );
                  })}
                  {Object.keys(ConsultationData).map((key, index) => {
                    return (
                      <div key={index}>
                        <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          Consultation Remarks
                        </p>
                        <input
                          className={`createTime ${show ? 'hide' : 'show'}`}
                          value={ConsultationData[key][`remarks`]}
                          style={{
                            padding: '5px',
                            outline: 'none',
                            border: '0px'
                          }}
                          onChange={e => {
                            setConsultationData(prevData => {
                              const newData = [...prevData];
                              newData[index] = {
                                ...newData[index],
                                remarks: e.target.value
                              };
                              return newData;
                            });
                          }}
                        />
                        <p className={`createTime ${!show ? 'hide' : 'show'}`}>{ConsultationData[key][`remarks`]}</p>
                      </div>
                    );
                  })}
                </td>
                <td style={{border: '1px solid', padding: '10px'}}>
                  {Object.keys(ScanData).map((key, index) => {
                    return (
                      <div>
                        <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          Scan price
                        </p>
                        <input
                          className={`createTime ${show ? 'hide' : 'show'}`}
                          name={`Price`}
                          value={ScanData[key][`price`]}
                          type='text'
                          style={{
                            padding: '5px',
                            outline: 'none',
                            border: '0px'
                          }}
                          onChange={e => {
                            setScanData(prevData => {
                              const newData = [...prevData];
                              newData[index] = {
                                ...newData[index],
                                price: e.target.value
                              };
                              return newData;
                            });
                          }}
                        />
                        <p className={`createTime ${!show ? 'hide' : 'show'}`}>{ScanData[key][`price`]}</p>
                      </div>
                    );
                  })}
                  {Object.keys(ProcedureData).map((key, index) => {
                    return (
                      <div>
                        <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          Procedure price
                        </p>
                        <input
                          className={`createTime ${show ? 'hide' : 'show'}`}
                          name={`Price`}
                          value={ProcedureData[key][`price`]}
                          type='text'
                          style={{
                            padding: '5px',
                            outline: 'none',
                            border: '0px'
                          }}
                          onChange={e => {
                            setProcedureData(prevData => {
                              const newData = [...prevData];
                              newData[index] = {
                                ...newData[index],
                                price: e.target.value
                              };
                              return newData;
                            });
                          }}
                        />
                        <p className={`createTime ${!show ? 'hide' : 'show'}`}>{ProcedureData[key][`price`]}</p>
                      </div>
                    );
                  })}
                  {Object.keys(ConsultationData).map((key, index) => {
                    return (
                      <div>
                        <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          Consultation price
                        </p>
                        <input
                          className={`createTime ${show ? 'hide' : 'show'}`}
                          name={`Price`}
                          value={ConsultationData[key][`price`]}
                          type='number'
                          style={{
                            padding: '5px',
                            outline: 'none',
                            border: '0px'
                          }}
                          onChange={e => {
                            setConsultationData(prevData => {
                              const newData = [...prevData];
                              newData[index] = {
                                ...newData[index],
                                price: e.target.value
                              };
                              return newData;
                            });
                          }}
                        />

                        <p className={`createTime ${!show ? 'hide' : 'show'}`}>{ConsultationData[key][`price`]}</p>
                      </div>
                    );
                  })}
                </td>
                <td style={{border: '1px solid', padding: '10px'}}>
                  {Object.keys(ScanData).map((key, index) => {
                    return (
                      <div>
                        <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          Scan Concession
                        </p>
                        <input
                          className={`createTime ${show ? 'hide' : 'show'}`}
                          name={`concession`}
                          value={ScanData[key][`concession`]}
                          type='text'
                          style={{
                            padding: '5px',
                            outline: 'none',
                            border: '0px'
                          }}
                          onChange={e => {
                            setScanData(prevData => {
                              const newData = [...prevData];
                              newData[index] = {
                                ...newData[index],
                                concession: e.target.value
                              };
                              return newData;
                            });
                          }}
                        />
                        <p className={`createTime ${!show ? 'hide' : 'show'}`}>{ScanData[key][`concession`]}</p>
                      </div>
                    );
                  })}
                  {Object.keys(ProcedureData).map((key, index) => {
                    return (
                      <div>
                        <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          Procedure Concession
                        </p>
                        <input
                          className={`createTime ${show ? 'hide' : 'show'}`}
                          name={`concession`}
                          value={ProcedureData[key][`concession`]}
                          type='text'
                          style={{
                            padding: '5px',
                            outline: 'none',
                            border: '0px'
                          }}
                          onChange={e => {
                            setProcedureData(prevData => {
                              const newData = [...prevData];
                              newData[index] = {
                                ...newData[index],
                                concession: e.target.value
                              };
                              return newData;
                            });
                          }}
                        />
                        <p className={`createTime ${!show ? 'hide' : 'show'}`}>{ProcedureData[key][`concession`]}</p>
                      </div>
                    );
                  })}
                  {Object.keys(ConsultationData).map((key, index) => {
                    return (
                      <div>
                        <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          Consultation Concession
                        </p>
                        <input
                          className={`createTime ${show ? 'hide' : 'show'}`}
                          name={`concession`}
                          value={ConsultationData[key][`concession`]}
                          type='number'
                          style={{
                            padding: '5px',
                            outline: 'none',
                            border: '0px'
                          }}
                          onChange={e => {
                            setConsultationData(prevData => {
                              const newData = [...prevData];
                              newData[index] = {
                                ...newData[index],
                                concession: e.target.value
                              };
                              return newData;
                            });
                          }}
                        />

                        <p className={`createTime ${!show ? 'hide' : 'show'}`}>{ConsultationData[key][`concession`]}</p>
                      </div>
                    );
                  })}
                </td>
              </tr>

              {show ? (
                (PharmacyData.Pharmacy.length !== 0 || PharmacyData.Refer_Prescription.length !== 0 || PharmacyData.price.length !== 0) && (
                  <tr
                    style={{
                      borderBottom: '1px solid',
                      borderSpacing: '0px',
                      borderCollapse: 'collapse'
                      // borderLeft: "1px solid",
                    }}
                    className='transition'>
                    <td
                      style={{
                        border: '1px solid',
                        padding: '10px',
                        borderTop: '0px',
                        BorderLeft: '0px',
                        borderBottom: '0px'
                      }}>
                      <div>
                        <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          Pharmacy
                        </p>
                        <input
                          className={`createTime ${show ? 'hide' : 'show'}`}
                          name={`Pharmacy`}
                          value={PharmacyData.Pharmacy}
                          type='text'
                          style={{
                            padding: '5px',
                            outline: 'none',
                            border: '0px'
                          }}
                          onChange={e => {
                            setPharmacyData({
                              ...PharmacyData,
                              [e.target.name]: e.target.value
                            });
                          }}
                        />

                        <p className={`createTime ${!show ? 'hide' : 'show'}`}>
                          {PharmacyData.Pharmacy != '' ? PharmacyData.Pharmacy : PharmacyData.price != '' && PharmacyData.Pharmacy == '' ? 'Pharmacy' : null}
                        </p>
                      </div>
                    </td>
                    <td
                      style={{
                        border: '1px solid',
                        padding: '10px',
                        borderTop: '0px',
                        BorderLeft: '0px',
                        borderBottom: '0px'
                      }}>
                      <div>
                        <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          Refer Prescription
                        </p>
                        <input
                          className={`createTime ${show ? 'hide' : 'show'}`}
                          name={`Refer_Prescription`}
                          value={PharmacyData.Refer_Prescription}
                          type='text'
                          style={{
                            padding: '5px',
                            outline: 'none',
                            border: '0px'
                          }}
                          onChange={e => {
                            setPharmacyData({
                              ...PharmacyData,
                              [e.target.name]: e.target.value
                            });
                          }}
                        />

                        <p className={`createTime ${!show ? 'hide' : 'show'}`}>{PharmacyData.Refer_Prescription}</p>
                      </div>
                    </td>{' '}
                    <td
                      style={{
                        border: '1px solid',
                        padding: '10px',
                        borderTop: '0px',
                        BorderLeft: '0px',
                        borderBottom: '0px'
                      }}>
                      <div>
                        <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          Pharmacy Price
                        </p>
                        <input
                          className={`createTime ${show ? 'hide' : 'show'}`}
                          name={`price`}
                          value={PharmacyData.price}
                          type='number'
                          style={{
                            padding: '5px',
                            outline: 'none',
                            border: '0px'
                          }}
                          onChange={e => {
                            setPharmacyData({
                              ...PharmacyData,
                              [e.target.name]: e.target.value
                            });
                          }}
                        />

                        <p className={`createTime ${!show ? 'hide' : 'show'}`}>{PharmacyData.price}</p>
                      </div>
                    </td>
                    <td
                      style={{
                        border: '1px solid',
                        padding: '10px',
                        borderTop: '0px',
                        BorderLeft: '0px',
                        borderBottom: '0px'
                      }}>
                      <div>
                        <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          Pharmacy Concession
                        </p>
                        <input
                          className={`createTime ${show ? 'hide' : 'show'}`}
                          name={`concession`}
                          value={PharmacyData.concession}
                          type='number'
                          style={{
                            padding: '5px',
                            outline: 'none',
                            border: '0px'
                          }}
                          onChange={e => {
                            setPharmacyData({
                              ...PharmacyData,
                              [e.target.name]: e.target.value
                            });
                          }}
                        />

                        <p className={`createTime ${!show ? 'hide' : 'show'}`}>{PharmacyData.concession}</p>
                      </div>
                    </td>
                  </tr>
                )
              ) : (
                <tr
                  style={{
                    borderBottom: '1px solid',
                    borderSpacing: '0px',
                    borderCollapse: 'collapse'
                    // borderLeft: "1px solid",
                  }}
                  className='transition'>
                  <td
                    style={{
                      border: '1px solid',
                      padding: '10px',
                      borderTop: '0px',
                      BorderLeft: '0px',
                      borderBottom: '0px'
                    }}>
                    <div>
                      <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                        Pharmacy
                      </p>
                      <input
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name={`Pharmacy`}
                        value={PharmacyData.Pharmacy}
                        type='text'
                        style={{
                          padding: '5px',
                          outline: 'none',
                          border: '0px'
                        }}
                        onChange={e => {
                          setPharmacyData({
                            ...PharmacyData,
                            [e.target.name]: e.target.value
                          });
                        }}
                      />

                      <p className={`createTime ${!show ? 'hide' : 'show'}`}>
                        {PharmacyData.Pharmacy != '' ? PharmacyData.Pharmacy : PharmacyData.price != '' && PharmacyData.Pharmacy == '' ? 'Pharmacy' : null}
                      </p>
                    </div>
                  </td>
                  <td
                    style={{
                      border: '1px solid',
                      padding: '10px',
                      borderTop: '0px',
                      BorderLeft: '0px',
                      borderBottom: '0px'
                    }}>
                    <div>
                      <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                        Refer Prescription
                      </p>
                      <input
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name={`Refer_Prescription`}
                        value={PharmacyData.Refer_Prescription}
                        type='text'
                        style={{
                          padding: '5px',
                          outline: 'none',
                          border: '0px'
                        }}
                        onChange={e => {
                          setPharmacyData({
                            ...PharmacyData,
                            [e.target.name]: e.target.value
                          });
                        }}
                      />

                      <p className={`createTime ${!show ? 'hide' : 'show'}`}>{PharmacyData.Refer_Prescription}</p>
                    </div>
                  </td>{' '}
                  <td
                    style={{
                      border: '1px solid',
                      padding: '10px',
                      borderTop: '0px',
                      BorderLeft: '0px',
                      borderBottom: '0px'
                    }}>
                    <div>
                      <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                        Pharmacy Price
                      </p>
                      <input
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name={`price`}
                        value={PharmacyData.price}
                        type='text'
                        style={{
                          padding: '5px',
                          outline: 'none',
                          border: '0px'
                        }}
                        onChange={e => {
                          setPharmacyData({
                            ...PharmacyData,
                            [e.target.name]: e.target.value
                          });
                        }}
                      />
                      <p className={`createTime ${!show ? 'hide' : 'show'}`}>{PharmacyData.price}</p>
                    </div>
                  </td>
                  <td
                    style={{
                      border: '1px solid',
                      padding: '10px',
                      borderTop: '0px',
                      BorderLeft: '0px',
                      borderBottom: '0px'
                    }}>
                    <div>
                      <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                        Pharmacy Concession
                      </p>
                      <input
                        className={`createTime ${show ? 'hide' : 'show'}`}
                        name={`concession`}
                        value={PharmacyData.concession}
                        type='number'
                        style={{
                          padding: '5px',
                          outline: 'none',
                          border: '0px'
                        }}
                        onChange={e => {
                          setPharmacyData({
                            ...PharmacyData,
                            [e.target.name]: e.target.value
                          });
                        }}
                      />

                      <p className={`createTime ${!show ? 'hide' : 'show'}`}>{PharmacyData.concession}</p>
                    </div>
                  </td>
                </tr>
              )}
              {show ? (
                (InjectionData[0].Injection.length > 0 || InjectionData[0].Items.length > 0 || InjectionData[0].price.length > 0) && (
                  <tr
                    style={{
                      borderBottom: '1px solid',
                      borderSpacing: '0px',
                      borderCollapse: 'collapse'
                    }}
                    className='transition'>
                    <td
                      style={{
                        border: '1px solid',
                        padding: '10px',
                        borderTop: '0px',
                        BorderLeft: '0px',
                        borderBottom: '0px'
                      }}>
                      {InjectionData.map((item, index) => (
                        <div key={index}>
                          <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                            Injection
                          </p>
                          <div className={`createTime ${show ? 'hide' : 'show'}`}>
                            <SelectPicker
                              data={injections} // Replace with actual data array
                              style={{width: 300}}
                              searchable
                              placeholder='Select Group'
                              value={item.Injection}
                              onChange={e => {
                                setInjuctionData(prevData => {
                                  const newData = [...prevData];
                                  newData[index] = {
                                    ...newData[index],
                                    Injection: e || '',
                                    price: e ? price[e] : ''
                                  };

                                  return newData;
                                });
                              }}
                            />
                            {index === 0 ? (
                              <button className={`Plus ${show ? 'hide' : 'show'}`} onClick={() => add('injection')}>
                                +
                              </button>
                            ) : (
                              <button className={`minus ${show ? 'hide' : 'show'}`} onClick={() => sub('injection', index)}>
                                -
                              </button>
                            )}
                          </div>
                          <p className={`createTime ${!show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                            {InjectionData[index][`Injection`] != ''
                              ? InjectionData[index][`Injection`]
                              : InjectionData[index][`Injection`] == '' && InjectionData[index][`price`] != ''
                              ? 'Injection'
                              : null}
                            {/* {item.Injection} */}
                          </p>
                        </div>
                      ))}
                    </td>
                    <td
                      style={{
                        border: '1px solid',
                        padding: '10px',
                        borderTop: '0px',
                        BorderLeft: '0px',
                        borderBottom: '0px'
                      }}>
                      {Object.keys(InjectionData).map((key, index) => {
                        return (
                          <div key={index}>
                            <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                              Remarks
                            </p>
                            <input
                              className={`createTime ${show ? 'hide' : 'show'}`}
                              value={InjectionData[key][`Items`]}
                              style={{
                                padding: '5px',
                                outline: 'none',
                                border: '0px'
                              }}
                              onChange={e => {
                                setInjuctionData(prevData => {
                                  const newData = [...prevData];
                                  newData[index] = {
                                    ...newData[index],
                                    Items: e.target.value
                                  };
                                  return newData;
                                });
                              }}
                            />
                            <p className={`createTime ${!show ? 'hide' : 'show'}`}>{InjectionData[index][`Items`]}</p>
                          </div>
                        );
                      })}
                    </td>{' '}
                    <td
                      style={{
                        border: '1px solid',
                        padding: '10px',
                        borderTop: '0px',
                        BorderLeft: '0px',
                        borderBottom: '0px'
                      }}>
                      {Object.keys(InjectionData).map((key, index) => {
                        return (
                          <div>
                            <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                              Injection Price
                            </p>
                            <input
                              className={`createTime ${show ? 'hide' : 'show'}`}
                              name={`Price`}
                              value={InjectionData[key][`price`]}
                              type='number'
                              style={{
                                padding: '5px',
                                outline: 'none',
                                border: '0px'
                              }}
                              onChange={e => {
                                setInjuctionData(prevData => {
                                  const newData = [...prevData];
                                  newData[index] = {
                                    ...newData[index],
                                    price: e.target.value
                                  };
                                  return newData;
                                });
                              }}
                            />
                            <p className={`createTime ${!show ? 'hide' : 'show'}`}>{InjectionData[index][`price`]}</p>
                          </div>
                        );
                      })}
                    </td>
                    <td
                      style={{
                        border: '1px solid',
                        padding: '10px',
                        borderTop: '0px',
                        BorderLeft: '0px',
                        borderBottom: '0px'
                      }}>
                      {Object.keys(InjectionData).map((key, index) => {
                        return (
                          <div>
                            <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                              Injection Concession
                            </p>
                            <input
                              className={`createTime ${show ? 'hide' : 'show'}`}
                              name={`concession`}
                              value={InjectionData[key][`concession`]}
                              type='number'
                              style={{
                                padding: '5px',
                                outline: 'none',
                                border: '0px'
                              }}
                              onChange={e => {
                                setInjuctionData(prevData => {
                                  const newData = [...prevData];
                                  newData[index] = {
                                    ...newData[index],
                                    concession: e.target.value
                                  };
                                  return newData;
                                });
                              }}
                            />
                            <p className={`createTime ${!show ? 'hide' : 'show'}`}>{InjectionData[index][`concession`]}</p>
                          </div>
                        );
                      })}
                    </td>
                  </tr>
                )
              ) : (
                // )
                <tr
                  style={{
                    borderBottom: '1px solid',
                    borderSpacing: '0px',
                    borderCollapse: 'collapse'
                  }}
                  className='transition'>
                  <td
                    style={{
                      border: '1px solid',
                      padding: '10px',
                      borderTop: '0px',
                      BorderLeft: '0px',
                      borderBottom: '0px'
                    }}>
                    {InjectionData.map((item, index) => (
                      <div key={index}>
                        <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          Injection
                        </p>
                        <div className={`createTime ${show ? 'hide' : 'show'}`}>
                          <SelectPicker
                            data={injections} // Replace with actual data array
                            style={{width: 300}}
                            searchable
                            placeholder='Select Group'
                            value={item.Injection}
                            onChange={e => {
                              setInjuctionData(prevData => {
                                const newData = [...prevData];
                                newData[index] = {
                                  ...newData[index],
                                  Injection: e || '',
                                  price: e ? price[e] : ''
                                };

                                return newData;
                              });
                            }}
                          />
                          {index === 0 ? (
                            <button className={`Plus ${show ? 'hide' : 'show'}`} onClick={() => add('injection')}>
                              +
                            </button>
                          ) : (
                            <button className={`minus ${show ? 'hide' : 'show'}`} onClick={() => sub('injection', index)}>
                              -
                            </button>
                          )}
                        </div>
                        <p className={`createTime ${!show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                          {InjectionData[index][`Injection`] != ''
                            ? InjectionData[index][`Injection`]
                            : InjectionData[index][`Injection`] == '' && InjectionData[index][`price`] != ''
                            ? 'Injection'
                            : null}
                          {/* {item.Injection} */}
                        </p>
                      </div>
                    ))}
                  </td>
                  <td
                    style={{
                      border: '1px solid',
                      padding: '10px',
                      borderTop: '0px',
                      BorderLeft: '0px',
                      borderBottom: '0px'
                    }}>
                    {Object.keys(InjectionData).map((key, index) => {
                      return (
                        <div key={index}>
                          <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                            Remarks
                          </p>
                          <input
                            className={`createTime ${show ? 'hide' : 'show'}`}
                            value={InjectionData[key][`Items`]}
                            style={{
                              padding: '5px',
                              outline: 'none',
                              border: '0px'
                            }}
                            onChange={e => {
                              setInjuctionData(prevData => {
                                const newData = [...prevData];
                                newData[index] = {
                                  ...newData[index],
                                  Items: e.target.value
                                };
                                return newData;
                              });
                            }}
                          />
                          <p className={`createTime ${!show ? 'hide' : 'show'}`}>{InjectionData[index][`Items`]}</p>
                        </div>
                      );
                    })}
                  </td>{' '}
                  <td
                    style={{
                      border: '1px solid',
                      padding: '10px',
                      borderTop: '0px',
                      BorderLeft: '0px',
                      borderBottom: '0px'
                    }}>
                    {Object.keys(InjectionData).map((key, index) => {
                      return (
                        <div>
                          <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                            Injection Price
                          </p>
                          <input
                            className={`createTime ${show ? 'hide' : 'show'}`}
                            name={`Price`}
                            value={InjectionData[key][`price`]}
                            type='text'
                            style={{
                              padding: '5px',
                              outline: 'none',
                              border: '0px'
                            }}
                            onChange={e => {
                              setInjuctionData(prevData => {
                                const newData = [...prevData];
                                newData[index] = {
                                  ...newData[index],
                                  price: e.target.value
                                };
                                return newData;
                              });
                            }}
                          />
                          <p className={`createTime ${!show ? 'hide' : 'show'}`}>{InjectionData[index][`price`]}</p>
                        </div>
                      );
                    })}
                  </td>
                  <td
                    style={{
                      border: '1px solid',
                      padding: '10px',
                      borderTop: '0px',
                      BorderLeft: '0px',
                      borderBottom: '0px'
                    }}>
                    {Object.keys(InjectionData).map((key, index) => {
                      return (
                        <div>
                          <p className={`createTime ${show ? 'hide' : 'show'}`} style={{display: 'block', width: '100%'}}>
                            Injection Concession
                          </p>
                          <input
                            className={`createTime ${show ? 'hide' : 'show'}`}
                            name={`concession`}
                            value={InjectionData[key][`concession`]}
                            type='number'
                            style={{
                              padding: '5px',
                              outline: 'none',
                              border: '0px'
                            }}
                            onChange={e => {
                              setInjuctionData(prevData => {
                                const newData = [...prevData];
                                newData[index] = {
                                  ...newData[index],
                                  concession: e.target.value
                                };
                                return newData;
                              });
                            }}
                          />
                          <p className={`createTime ${!show ? 'hide' : 'show'}`}>{InjectionData[index][`concession`]}</p>
                        </div>
                      );
                    })}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div
          style={{
            maxWidth: '97%',
            margin: '0 auto',
            borderTop: '1px solid',
            width: '100%'
          }}>
          <div
            style={{
              // display: "grid",
              // gridTemplateColumns: "1fr 1fr",
              // alignItems: "start",
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: '32px',
              overflowX: 'hidden',
              maxWidth: '97%',
              margin: '0 auto'
            }}
            className='report-template-wrap2'>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'center',
                gap: '20px',
                padding: '16px 8px',
                width: '100%'
              }}>
              <div>
                <label className={`createTime `} style={{marginRight: '10px'}}>
                  <span style={{fontWeight: 600}}>Mode of Payment</span>
                  <span style={{fontWeight: 600, paddingLeft: '21px'}}>:</span>
                </label>

                {/* <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => {handleChange(e); console.log(valueChange.cash);}}
                  value={valueChange.cash}
                  name="cash"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px 20px",
                    backgroundColor: "white",
                  }}
                >
                  <option value="" disabled selected>
                    Select Payment Method
                  </option>
                  <option value="Cash">Cash</option>
                  <option value="Card">Card</option>
                  <option value="UPI">UPI</option>
                </select>
                <span
                  className={`input ${!show ? "hide" : "show"}`}
                  style={{ fontSize: "16px" }}
                >
                  &nbsp;{valueChange.cash}
                </span> */}

                <div style={{display: 'flex', flexDirection: 'row', gap: '50px'}} className={`createTime ${show ? 'hide' : 'show'} modeOfPmt`}>
                  <section>
                    <input type='checkbox' value='cash' onClick={paymentType}></input>
                    <label>Cash :</label>
                    <input type='text' value={amountInPmt.amount_one} disabled={cashTru} name='amount_one' onInput={amountEnter}></input>
                  </section>
                  <section>
                    <input type='checkbox' value='card' onClick={paymentType}></input>
                    <label>Card :</label>
                    <input type='text' value={amountInPmt.amount_two} disabled={cardTru} name='amount_two' onInput={amountEnter}></input>
                  </section>
                  <section>
                    <input type='checkbox' value='upi' onClick={paymentType}></input>
                    <label>UPI :</label>
                    <input type='text' value={amountInPmt.amount_three} disabled={upiTru} name='amount_three' onInput={amountEnter}></input>
                  </section>
                  <section>
                    <input type='checkbox' value='neft' onClick={paymentType}></input>
                    <label>Neft :</label>
                    <input type='text' value={amountInPmt.amount_four} disabled={neftTru} name='amount_four' onInput={amountEnter}></input>
                  </section>
                </div>

                <div>
                  <span className={`input ${!show ? 'hide' : 'show'}`} style={{fontSize: '16px'}}>
                    <b>Cash :</b>&nbsp;&nbsp;{amountInPmt.amount_one}&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>

                  <span className={`input ${!show ? 'hide' : 'show'}`} style={{fontSize: '16px'}}>
                    <b>Card :</b>&nbsp;&nbsp;{amountInPmt.amount_two}&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>

                  <span className={`input ${!show ? 'hide' : 'show'}`} style={{fontSize: '16px'}}>
                    <b>UPI :</b>&nbsp;&nbsp;{amountInPmt.amount_three}&nbsp;&nbsp;&nbsp;&nbsp;
                  </span>
                  <span className={`input ${!show ? 'hide' : 'show'}`} style={{fontSize: '16px'}}>
                    <b>NEFT :</b>&nbsp;&nbsp;{amountInPmt.amount_four}
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center'
                  // gridTemplateColumns: "152px 16px 176px",
                }}>
                <span style={{fontWeight: 600}}>Total(In words)</span>
                <span style={{fontWeight: 600, paddingLeft: '43px'}}>:</span>
                <p
                  style={{
                    margin: '0',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingLeft: '5px'
                  }}>
                  {<NumbersToWords number={discountCalculator(valueChange?.disc)} />}
                </p>
              </div>
              {/* Total*/}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '152px 34px 176px',
                  alignItems: 'center'
                }}>
                <span style={{fontWeight: 600}}>Total</span>
                <span style={{fontWeight: 600, paddingLeft: '19px'}}>:</span>
                <p style={{margin: '0'}}>{total}/-</p>
              </div>

              {/* Disc*/}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '152px 33px 176px',
                  alignItems: 'center'
                }}>
                <span style={{fontWeight: 600}}>Concession</span>
                <span style={{fontWeight: 600, paddingLeft: '19px'}}>:</span>
                <input
                  type='number'
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  onChange={e => handleChange(e)}
                  name='disc'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px'
                  }}
                />
                {/* <span>&nbsp;%</span> */}
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{valueChange.disc}</span>
              </div>

              {/* Net amount */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '152px 33px 176px',
                  alignItems: 'center'
                }}>
                <span style={{fontWeight: 600}}>Net Amount</span>
                <span style={{fontWeight: 600, paddingLeft: '19px'}}>:</span>

                <p style={{margin: '0'}}>{Math.round(discountCalculator(valueChange.disc))}/-</p>
                {/* <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{valueChange.netAmount}</span> */}
              </div>

              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '152px 33px 176px',
                  alignItems: 'center'
                }}>
                <span style={{fontWeight: 600}}>Returned Amount</span>
                <span style={{fontWeight: 600, paddingLeft: '19px'}}>:</span>

                <p style={{margin: '0'}}>{Math.round(valueChange.returnedBalance)}/-</p>

                {/* <span className={`input ${!show ? 'hide' : 'show'}`}>{valueChange.returnedBalance}/-</span> */}
              </div>
            </div>
          </div>
        </div>
        <>
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'center',
              overflowX: 'hidden',
              maxWidth: '97%',
              margin: '0 auto',
              // borderBottom: "1px solid",
              borderTop: 'none',
              width: '100%'
            }}
            className='report-template-wrap1'>
            <div className='' style={{width: '100%'}} id='patientInfo1'>
              <div
                style={{
                  display: 'flex',
                  // flexDirection: "column",
                  // alignItems: "center",
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  // gap: "10px",
                  // borderRadius: "6px",
                  padding: '16px 29px',
                  height: '100%',
                  width: '100%'
                }}>
                {/* <p style={{ margin: "0", paddingTop: "50px" }}>
                  Authorized Signature
                </p> */}
              </div>
            </div>
          </div>
          <p style={{textAlign: 'center'}}>----------------------X----------------------</p>
        </>
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <button onClick={handleBill} className={`Button_Create createTime ${show ? 'hide' : 'show'}`}>
            Generate Bill
          </button>
        </div>
      </div>
    </>
  );
}

export default BillGenerateTemplate;
